var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservedSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7690",
    "data-name": "Group 7690",
    transform: "translate(-191 -514)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23606",
    "data-name": "Ellipse 23606",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(191 514)",
    fill: "#4f5b6d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7689",
    "data-name": "Group 7689",
    transform: "translate(-40.418 234.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M240.81,288.6l1.559,2.241a.969.969,0,0,1-.376,1.322,1,1,0,0,1-1.322-.278l-1.837-3.034H237.9v2.505a.991.991,0,0,1-1.017.947,1.02,1.02,0,0,1-1.016-.947v-7.668a.978.978,0,0,1,.975-1.044h2.936a3.012,3.012,0,0,1,3.188,3.09A2.975,2.975,0,0,1,240.81,288.6Zm-2.909-4.161v2.7h1.823a1.362,1.362,0,0,0,.055-2.7Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservedSlot);
export default __webpack_public_path__ + "static/media/reserved-slot.3a68173e260456480673275c16abeaa0.svg";
export { ForwardRef as ReactComponent };